@if (canShowItem(model.firma)) {
    <div class="angaben__group">
        <div class="angaben__label">Firma</div>
        <div class="angaben__value">{{ model.firma.value }}</div>
    </div>
}

<div class="angaben__group">
    <div class="angaben__label">Ansprechpartner</div>
    <div class="angaben__value">
        @if (canShowItem(model.vorname)) {
            {{ model.vorname.value }}
        }&nbsp;@if (canShowItem(model.nachname)) {
        {{ model.nachname.value }}
    }
    </div>
    @if (canShowItemMultipleInputs(model.vorwahl, model.rufnummer)) {
        <div class="angaben__value">
            {{ model.vorwahl.value }}&nbsp;{{ model.rufnummer.value }}
        </div>
    }
    @if (canShowItem(model.email)) {
        <div class="angaben__value">
            {{ model.email.value }}
        </div>
    }
</div>

@if (canShowItem(model.street)) {
    <div class="angaben__group">
        <div class="angaben__label">Anschrift</div>
        @if (canShowItem(model.street)) {
            <div class="angaben__value">
                {{ model.street.value }}
            </div>
        }
        <div class="angaben__value">
            @if (canShowItem(model.plz)) {
                {{ model.plz.value }}
            }&nbsp;@if (canShowItem(model.ort)) {
            {{ model.ort.value }}
        }
        </div>
    </div>
}

@if (canShowItem(model.vertrag)) {
    <div class="angaben__group">
        <div class="angaben__label">Vertragsnummer</div>
        <div class="angaben__value">{{ model.vertrag.value }}</div>
    </div>
}

@if (!printMode) {
    <div class="angaben__button">
        <elem-button icon="icon-edit_1"
                     buttonRole="SMALL"
                     (click)="context.setCreationState(context.STATE_1_ANTRAGSTELLER, false)">
            Ändern
        </elem-button>
    </div>
}
